export default __webpack_public_path__ + "static/media/hip.bfcf877a.png";